import { Box, Button, HStack, Menu, MenuButton, MenuDivider, MenuItem, MenuItemOption, MenuList, MenuOptionGroup, Text } from "@chakra-ui/react";
import { ChevronDown, Star } from "../../../shared/icons";
import VinculoColorDot from "../../vinculos/components/VinculoColorDot";
import { sortFavoritesFirst } from "../../vinculos/utils/sortFavoritesFirst";

function buttonLabel(vinculos, selectedIds) {
  if (selectedIds.length === 0) return "Todos os vínculos";
  if (selectedIds.length === 1) return vinculos.find((v) => v.id === selectedIds[0])?.nome ?? "1 vínculo";
  return `${selectedIds.length} vínculos`;
}

// Filtro por vínculo (um ou vários), combinado com o de status. Menu com caixas de
// marcar — funciona com toque — e "Todos os vínculos" para limpar; favoritos primeiro,
// com a cor de cada vínculo. `selectedIds` vazio = todos.
export default function VinculoFilterMenu({ vinculos = [], selectedIds, onChange }) {
  return (
    <Menu closeOnSelect={false} placement="bottom-start" isLazy>
      <MenuButton
        as={Button}
        size="sm"
        variant={selectedIds.length > 0 ? "solid" : "outline"}
        rightIcon={<ChevronDown size={14} />}
        aria-label={`Filtrar por vínculo: ${buttonLabel(vinculos, selectedIds)}`}
        maxW="240px"
      >
        <Text as="span" noOfLines={1}>
          {buttonLabel(vinculos, selectedIds)}
        </Text>
      </MenuButton>
      <MenuList maxH="60vh" overflowY="auto" zIndex="dropdown">
        <MenuItem onClick={() => onChange([])} fontWeight={selectedIds.length === 0 ? "semibold" : "normal"}>
          Todos os vínculos
        </MenuItem>
        <MenuDivider />
        <MenuOptionGroup
          type="checkbox"
          value={selectedIds.map(String)}
          onChange={(values) => onChange((Array.isArray(values) ? values : [values]).map(Number))}
        >
          {sortFavoritesFirst(vinculos).map((vinculo) => (
            <MenuItemOption key={vinculo.id} value={String(vinculo.id)}>
              <HStack spacing={2}>
                <VinculoColorDot cor={vinculo.cor} size="8px" />
                <Text as="span" noOfLines={1}>
                  {vinculo.nome}
                </Text>
                {vinculo.favorito ? (
                  <Box as="span" color="warning.500" display="inline-flex" role="img" aria-label="Favorito">
                    <Star size={12} fill="currentColor" aria-hidden />
                  </Box>
                ) : null}
              </HStack>
            </MenuItemOption>
          ))}
        </MenuOptionGroup>
      </MenuList>
    </Menu>
  );
}
